import { LoggedOutOrNoJiraProductTourOverview } from "@/templates/software/jira/logged-out/jira-software-logged-out-page/src";

export const JiraLandingPage = () => {
    const template = <LoggedOutOrNoJiraProductTourOverview />;

    return template;
};
